import { removeClass } from 'utils/dom/class';
import html from 'utils/dom/html';
import isEmpty from 'utils/core/isEmpty';
import { request } from 'utils/request';
import { addToCartFormHandler } from 'ts/helpers/addToCartHandler';
import { trackProductDetailsViewUpdate } from 'ts/analytics';

const PRODUCT_DIMENSION_KEY = 'size';
const PRODUCT_VARIANTS_URL = '/ajax/productDetails?productCode=[productCode]';
const ATB_DISABLED = '.add-to-cart-disabled-button';
const DISABLED = 'disabled';
const variantSelectorElements = document.querySelectorAll('.variant-select');

const updateAddToBagSize = () => {
  const panel = document.querySelector('.product-panel__add-to-bag');
  const ATBForm = panel && panel.querySelector('.add_to_cart_form');

  if (!panel || !ATBForm) {
    return;
  }

  panel.classList[ATBForm.classList.contains('empty') ? 'add' : 'remove']('empty');
};

const updateProductDetails = (responseContent) => {
  const response = document.createElement('div');
  html(response, responseContent);

  const productNameContainer = document.getElementById('productName');
  const productNameValue = html(response.querySelector('#productName')).toString();
  html(productNameContainer, productNameValue);

  const productOfferContainer = document.getElementById('productOffer');
  const productOfferValue = html(response.querySelector('#productOffer')).toString();
  html(productOfferContainer, productOfferValue);

  const productAddToCartContainer = document.querySelectorAll('.prod-add-to-cart');
  const productAddToCartValue = html(response.querySelector('.prod-add-to-cart')).toString();
  [...productAddToCartContainer].forEach((container) => html(container, productAddToCartValue));

  const productStockCheckAvailabilityContainer = document.getElementById('productStockCheckAvailability');
  const productStockCheckAvailabilityValue = html(response.querySelector('#productStockCheckAvailability')).toString();
  html(productStockCheckAvailabilityContainer, productStockCheckAvailabilityValue);
  updateAddToBagSize();

  const productDescriptionContainer = document.getElementById('productDescription');
  const productDescriptionValue = html(response.querySelector('#productDescription')).toString();
  html(productDescriptionContainer, productDescriptionValue);

  const productPromotionsContainer = document.getElementById('productPromotions');
  const productPromotionsValue = html(response.querySelector('#productPromotions')).toString();
  html(productPromotionsContainer, productPromotionsValue);

  const productOfferAvailabilityContainer = document.getElementById('productOfferAvailability');
  const productOfferAvailabilityValue = html(response.querySelector('#productOfferAvailability')).toString();
  html(productOfferAvailabilityContainer, productOfferAvailabilityValue);

  const productVariantJson = response.querySelector('#productLayout1PageAjax').textContent || '';
  try {
    const productVariantData = JSON.parse(productVariantJson);
    window.globalProductDetails.selectedVariant = {
      ...productVariantData
    };
  } catch (error) {
    console.error(error.message);
  }
};

const clearProductVariantErrors = () => {
  const stockCheckErrorContainer = document.getElementById('stockCheckErrorMsg');
  const variantErrorContainer = document.getElementById('variantErrorContainer');

  html(variantErrorContainer, '');
  html(stockCheckErrorContainer, '');

  [...variantSelectorElements].forEach((element) => removeClass(element, 'parsley-error'));
};

const setProductVariantValue = (selectedValue) => {
  [...variantSelectorElements].forEach((element) => {
    if (element.nodeName === 'FORM') {
      Array.from(element).forEach((radioEl) => {
        radioEl.checked = radioEl.value === selectedValue;
      });
    }
  });
};

const productVariantSelectorHandler = (e) => {
  const addToBagButton = document.querySelector('.add-to-cart-button');
  let selectedValue = '';
  if (e.target.nodeName === 'FORM') {
    selectedValue = Array.from(e.target).filter((radio) => radio.checked)[0].value;
  }

  if (e.target.nodeName === 'INPUT') {
    selectedValue = e.target.value;
  }

  if (selectedValue) {
    setProductVariantValue(selectedValue);
  }

  clearProductVariantErrors();

  const disabledATB = document.querySelector(ATB_DISABLED);
  if (disabledATB) {
    disabledATB.classList.add(DISABLED);
  }

  if (addToBagButton) {
    addToBagButton.classList.add(DISABLED);
    addToBagButton.setAttribute(DISABLED, true);
  }

  return (
    !isEmpty(selectedValue) &&
    request(PRODUCT_VARIANTS_URL.replace(/\[productCode]/, selectedValue), {
      format: 'text'
    }).then((response) => {
      updateProductDetails(response);
      addToCartFormHandler();
      trackProductDetailsViewUpdate();
      if (addToBagButton) {
        addToBagButton.classList.remove(DISABLED);
        addToBagButton.setAttribute(DISABLED, false);
      }
      document.dispatchEvent(new CustomEvent('PDP_PRODUCT_VARIANTS_FETCHED_AND_DOM_UPDATED'));
    })
  );
};

const variants = () => {
  [...variantSelectorElements].forEach((selectorElement, index) => {
    selectorElement.parentElement.classList.remove('visibility-hidden');
    selectorElement.addEventListener('change', productVariantSelectorHandler);

    const urlSearchParams = new URLSearchParams(window.location.search.slice(1));
    const variantKey = urlSearchParams.get(PRODUCT_DIMENSION_KEY);

    if (variantKey === null) {
      return;
    }

    const preselectedOptionElement = [...selectorElement.children].find(({ textContent }) => {
      const variantTextContentSplit = textContent.trim().split(',');
      return variantTextContentSplit.length >= 1 && variantTextContentSplit[0].includes(variantKey);
    });

    if (selectorElement.nodeName === 'FORM') {
      const radioEl = preselectedOptionElement.children[0];
      radioEl.checked = true;
      const event = new CustomEvent('change');
      selectorElement.dispatchEvent(event);
    }

    if (variantSelectorElements.length - 1 === index) {
      urlSearchParams.delete(PRODUCT_DIMENSION_KEY);
      window.history.replaceState(
        {},
        document.title,
        window.location.origin +
          window.location.pathname +
          (urlSearchParams.toString() === '' ? '' : `?${urlSearchParams.toString()}`)
      );
    }
  });
};

export default variants;
